import { css } from '@emotion/react';
import { mediaQuery } from './mediaQuery.js';
import { propsEvalOrReturn } from './propsEvalOrReturn.js';
import { is, getThemeValue, merge, getValue, warn } from './variantUtils.js'; // forked from https://github.com/smooth-code/xstyled/blob/master/packages/system/src/variant.js

function evaluateVariant(props, parameters, resolvedValue) {
  var key = parameters.key,
      defaultValue = parameters.default,
      variants = parameters.variants;
  var value = resolvedValue || defaultValue;
  var themeVariants = is(key) ? getThemeValue(props, key) : {};
  var computedVariants = merge(variants, themeVariants);
  var result;

  if (value) {
    result = getValue(props, value, computedVariants);

    if (!is(result) && defaultValue && value !== defaultValue) {
      result = getValue(props, defaultValue, computedVariants);
    }
  }

  warn(is(result), "variant \"".concat(value || 'undefined', "\" not found"));
  return propsEvalOrReturn(result, props);
}

function variant(parameters) {
  var _parameters$key = parameters.key,
      key = _parameters$key === void 0 ? null : _parameters$key,
      _parameters$default = parameters.default,
      defaultValue = _parameters$default === void 0 ? 'default' : _parameters$default,
      _parameters$variants = parameters.variants,
      variants = _parameters$variants === void 0 ? {} : _parameters$variants,
      prop = parameters.prop;
  return function (props) {
    var themeVariants = is(key) ? getThemeValue(props, key) : {};
    var computedVariants = merge(variants, themeVariants);

    if (props.useVariantAsClass) {
      var isClassProp = typeof props.useVariantAsClass === 'string' && props.useVariantAsClass === prop;

      if (Array.isArray(props.useVariantAsClass)) {
        isClassProp = props.useVariantAsClass.indexOf(prop) > -1;
      }

      if (isClassProp) {
        var allKeys = Object.keys(computedVariants);
        var defaultSelector = allKeys.reduce(function (selector, variantKey) {
          var newString = '';

          if (variantKey !== defaultValue) {
            newString = ":not(.".concat(variantKey, ")");
          }

          return selector + newString;
        }, '');
        var classes = allKeys.map(function (variantKey) {
          return variantKey === defaultValue ? /*#__PURE__*/css("&", defaultSelector, "{", propsEvalOrReturn(computedVariants[variantKey], props), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:classes;")) : /*#__PURE__*/css("&.", variantKey, "{", propsEvalOrReturn(computedVariants[variantKey], props), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:classes;"));
        });
        return /*#__PURE__*/css(classes);
      }
    }

    return mediaQuery(prop, function (value) {
      return evaluateVariant(props, parameters, value);
    })(props);
  };
}

export { variant };
